import { useCallback } from 'react';
import { useLoginUserWithGoogleMutation } from 'shared/hooks/queries/use-login-user-with-google-mutation';

export const useLoginWithGoogle = () => {
  const { mutateAsync, error, reset, isPending } =
    useLoginUserWithGoogleMutation();

  const login = useCallback(async () => {
    try {
      await mutateAsync();
    } catch {
      // the mutation's `error` state carries the failure the page shows
    }
  }, [mutateAsync]);

  return { login, error: error?.kind, reset, isLoading: isPending };
};
